<template>
  <div class="container mol-typical-page-container-20 results-container">
    <div class="back-button">
      <router-link :to="`/oscar-pool/${club_id}`">
        <i class="fa fa-angle-double-left" aria-hidden="true"></i> Return to Oscar Pool
      </router-link>
    </div>

    <div class="card mol-center-card-width results-card">

      <div :class="`connection-indicator ${connectionReadyState}`">
        <div class="connection-indicator-fill"></div>
      </div>
      <OscarPoolResultsNewsFeed ref="newsFeed" class="news-feed"></OscarPoolResultsNewsFeed>

      <div v-if="resultsData"  class="card-header">
        <div v-if="clubData" class="club-title"><ClubPicture :club="clubData.club" size="18"></ClubPicture> {{ clubData.club.name }}</div>
        <h1>OSCAR POOL RESULTS</h1>
        <div class="ceremony-number-and-year">{{ ceremonyOrdinalText }} Ceremony • {{ ceremonyDateText }}</div>
        <div>Honoring achievements in</div>
        <div>{{ resultsData?.films?.length }} films from {{ ceremonyYearsHonoredText }}</div>
      </div>

      <div v-if="resultsData"  class="card-body">

        <table style="width:100%">
<!--
          <thead>
          <tr style="border-bottom: 1px solid black;">
            <th style="text-align: center;">roles</th>
            <th>name</th>
            <th>auth</th>
            <th>joined</th>
          </tr>
          </thead>
-->

          <transition-group name="leaderboard" tag="tbody">
            <tr
                v-for="(contestant, index) in resultsData.contestants"
                :key="contestant._id"
                :class="tableRowClassObject(index)"
            >
<!--
            <tr v-for="(contestant) in resultsData.contestants" :key="contestant._id" :class="{'no-top-border': true }">
-->

              <td class="image-table-data">
                <img v-if="(getPlacing(contestant._id) === 1) && ( (index === 0) || (contestant.score !== resultsData.contestants[index-1].score) )"
                     :src="`${$imagePathBase}place-ribbon-1.svg`" class="rank-image"/>
                <img v-if="(getPlacing(contestant._id) === 2) && ( (index === 0) || (contestant.score !== resultsData.contestants[index-1].score) )"
                     :src="`${$imagePathBase}place-ribbon-2.svg`" class="rank-image"/>
                <ColorThemeImg v-if="(getPlacing(contestant._id) === 3) && ( (index === 0) || (contestant.score !== resultsData.contestants[index-1].score) )"
                     :src="`${$imagePathBase}place-ribbon-3.svg`"
                     :dark_theme_src="`${$imagePathBase}place-ribbon-3-dark.svg`"
                     class="rank-image"/>
              </td>

              <td>
                <OscarPoolContestantScore :contestant="contestant"></OscarPoolContestantScore>
              </td>
            </tr>
          </transition-group>

        </table>

      </div>

      <div class="card-footer">
        contestants with no choices not shown
      </div>

    </div>
  </div>
</template>


<script>
// eslint-disable-next-line
import axios from "axios";
import {Film, Nomination} from "@/film";
import OscarPoolContestantScore from "@/components/clubs/oscar pool/OscarPoolContestantScore.vue";
import OscarPoolResultsNewsFeed from "@/components/clubs/oscar pool/OscarPoolResultsNewsFeed.vue";
import ClubPicture from "@/components/clubs/ClubPicture.vue";
import ColorThemeImg from "@/components/ColorThemeImg.vue";

const dateFormatObj = new Intl.DateTimeFormat('en-US', {
  timeZone: 'UTC',
  month: 'short',
  day: 'numeric',
  year: 'numeric'
});

export default {
  name: "OscarPoolLeaderboard",
  components: {ColorThemeImg, ClubPicture, OscarPoolResultsNewsFeed, OscarPoolContestantScore},
  props: ['ceremony', 'club_id'],
  data() {
    return {
      clubData: null,
      ceremonyState: 'connecting', // 'connecting', 'days-before-ceremony', 'hours-before-ceremony', 'minutes-before-ceremony', 'beginning-of-ceremony', 'next-category-announced', 'winner-announced', 'final-winner-announced'
      currentCategory: null,
      customMessage: null,

      resultsData: null,
      eventSource: null,
      connectionReadyState: '',
      streamMessage: 'connecting...',

    }
  },
  computed: {
    ceremonyOrdinalText() {
      return Film.getCeremonyOrdinalText(this.ceremony);
    },
    ceremonyDateText() {
      return dateFormatObj.format(Film.getDateOfCeremony(this.ceremony));
    },
    ceremonyYearsHonoredText() {
      return Film.ceremonyYearsHonoredText(this.ceremony);
    },
    allResultsDecided() {
      // All results are decided if there is NOT some category without a winning nomination
      return !this.resultsData?.categories?.some(cat => !cat.nomination_data.some(nom => nom.won));
    }
  },
  async mounted() {

    return this.getClubInfo()
        .then(() => this.getStaticResults())
        //.then(() => this.startEventStream()) // <- Now that oscar night is done, remove the event streaming
        .catch(err => {
          console.log(err);
        });

  },
  beforeUnmount() {
    this.eventSource?.close();
  },
  methods: {

    tableRowClassObject(_index) {
      const classObj = { };

      // add class for podium colors
      const contestant = this.resultsData.contestants[_index];
      const contestantPlacing = this.getPlacing(contestant._id);

      // 'podium rank' is same as placing, but only includes first, second and third place
      const contestantPodiumRank = (contestantPlacing && contestantPlacing <= 3) ? contestantPlacing : null;

      switch ( contestantPodiumRank ) {
        case 1: classObj['first-place'] = true; break;
        case 2: classObj['second-place'] = true; break;
        case 3: classObj['third-place'] = true; break;
      }

      // add class for line separating this contestant from the previous one
      const prevContestant = (_index > 0) ? this.resultsData.contestants[_index-1] : null;
      if ( prevContestant ) {
        const prevContestantPlacing = this.getPlacing(prevContestant._id);
        const prevContestantPodiumRank = (prevContestantPlacing && prevContestantPlacing <= 3) ? prevContestantPlacing : null;

        // if this contestant is the same placing as the previous one, don't draw a top border
        if ( prevContestantPodiumRank && (contestantPodiumRank === prevContestantPodiumRank) ) {
          classObj['no-top-border'] = true;
        }

        // if the previous contestant 'placed' but I did not, draw a double border
        if ( prevContestantPodiumRank && !contestantPodiumRank ) {
          classObj['double-top-border'] = true;
        }
      }

      return classObj;
    },

    getPlacing(_contestantId) {
      if ( !this.resultsData?.contestants ) {
        return null;
      }

      // make sorted array of unique scores
      const scores = [...new Set(this.resultsData?.contestants.map(c => c.score))].sort();
      const myScore = this.resultsData?.contestants.find(c => c._id === _contestantId).score;

      // nobody with a score of zero has a placement
      if ( myScore === 0 ) {
        return null;
      }

      // reduce starting witb 1 (first place) and adding one for each score we find higher than ours
      return scores.reduce((accNumHigherScores, curScore) => {
        return curScore > myScore ? accNumHigherScores + 1 : accNumHigherScores;
      }, 1);
    },

    async getStaticResults() {
      return axios.get(`/api/club/${this.club_id}/oscar-pool/results/static`)
          .then(response => {
            //console.log('oscar-pool/results response', response.data);
            //console.log('oscar-pool/results response headers', response.headers);
            this.resultsData = response.data;

            // remove each contentant's viewedCount, we don't really want to display that here
            this.resultsData.contestants?.forEach(contestant => contestant.viewedCount = undefined);

            this.addScoreJustifications();
          });
    },

    async getClubInfo() {
      return axios.get(`/api/club/${this.club_id}/oscar-pool/club-info`)
          .then(response => {
            this.clubData = response.data.club_info;
          });
    },

    updateConnectionReadyState() {
      this.connectionReadyState = (
        (this.eventSource?.readyState === EventSource.CONNECTING) ? 'connecting' :
          (this.eventSource?.readyState === EventSource.OPEN) ? 'open' :
            (this.eventSource?.readyState === EventSource.CLOSED) ? 'closed' : ''
      );
    },

    addScoreJustifications() {
      this.resultsData.contestants.forEach(contestant => {

        contestant.pointJustifications = this.resultsData.categories.reduce((accPointJustifications, curCategory) => {

          const winningNoms = curCategory.nomination_data.filter(n => n.won);

          const pointJustificationsForThisCategory = winningNoms.reduce((accJustificationsForCategory, curWinningNom) => {
            if ( contestant.choices.includes(curWinningNom.nom_id) ) {
              //const film = this.resultsData.films.find(f => f._id === winningNom.film_id);
              return [
                ...accJustificationsForCategory,
                //`${curCategory.points} points for picking ${film.name} for ${curCategory.name}`
                `+${curCategory.points} for ${curCategory.name}`
              ];
            }
            if ( contestant.second_choices?.includes(curWinningNom.nom_id) ) {
              //const film = this.resultsData.films.find(f => f._id === winningNom.film_id);
              return [
                ...accJustificationsForCategory,
                //`${curCategory.points_second_choice} points for picking ${film.name} as 2nd choice for ${curCategory.name}`
                `+${curCategory.points_second_choice} for ${curCategory.name} (2nd)`
              ];
            }
            return accJustificationsForCategory;
          }, []);

          return [...accPointJustifications, ...pointJustificationsForThisCategory];
        }, []);

      });
    },

    startEventStream() {
      // Initialize the EventSource, listening for server updates
      this.eventSource = new EventSource(`${this.$apiPath}/api/club/${this.club_id}/oscar-pool/results/live`);
      this.eventSource.addEventListener('scoreUpdate', this.onScoreUpdateEvent);
      this.eventSource.addEventListener('eventStreamInfo', this.onEventStreamInfo);
      this.eventSource.addEventListener('closeConnection', this.onConnectionClosedEvent);

      this.eventSource.onerror = this.onConnectionError;
      this.eventSource.onopen = this.onConnectionOpen;

      //this.$refs.newsFeed?.setMessages([`...connecting to server...`]);
      this.updateConnectionReadyState();
    },

    onEventStreamInfo(event) {
      const eventStreamInfo = JSON.parse(event.data);
      //console.log('eventStreamInfo', eventStreamInfo);
      this.ceremonyState = eventStreamInfo.ceremonyState;
      this.currentCategory = eventStreamInfo.currentCategory || null;
      this.customMessage = eventStreamInfo.customMessage || null;

      if ( this.customMessage ) {
        this.$refs.newsFeed?.setMessages([this.customMessage]);
      }
    },

    onScoreUpdateEvent(event) {

      // event.data format
      // {
      //   contestants: [ {_id, username, picture_url, membershipType, choices (film ids), second_choices (film ids), score} ]
      //   films: [ { _id, name } ],
      //   categories: [ name, points, points_second_choice, nomination_data: [ { nom_id, film_id, nominee, song_title, won } ] ],
      //   updatedNomIds: [ (nom ids) ]
      // }

      // save previous scores if they're available
      const previousScoreMap = new Map(this.resultsData?.contestants.map(c => [c._id, c.score]));
      this.resultsData = JSON.parse(event.data);
      this.resultsData.contestants.forEach(contestant => {
        contestant.viewedCount = undefined;

        //console.log(`previousScoreMap.get(${contestant._id})`, previousScoreMap.get(contestant._id))

        contestant.previousScore = previousScoreMap.get(contestant._id) ?? contestant.score;
        contestant.displayScore = contestant.previousScore;
      });
      this.addScoreJustifications();

      // start animating score display
      this.resultsData.startTime = performance.now();
      requestAnimationFrame(this.stepDisplayScoreAnimation);

      //console.log('resultsData', this.resultsData);

      const newsFeedItems = this.createScoreUpdateNewsfeedItems();
      if ( newsFeedItems ) {
        this.$refs.newsFeed.setMessages(newsFeedItems);
      }
    },

    stepDisplayScoreAnimation(currentTime) {
      const duration = 450;
      const elapsedTime = currentTime - this.resultsData.startTime;
      const progress = Math.min(elapsedTime / duration, 1); // Calculate progress (0 to 1)


      this.resultsData.contestants.forEach(c => {
        const scoreDifference = c.score - c.previousScore;
        c.displayScore = (progress < 1) ? c.previousScore + Math.floor(progress * scoreDifference) : c.score;
      });

      //console.log('displayScores', this.resultsData.contestants.map(c => c.displayScore));

      // Continue the animation if not finished
      if (progress < 1) {
        requestAnimationFrame(this.stepDisplayScoreAnimation);
      }
    },


    createScoreUpdateNewsfeedItems() {
      const updatedNomIds = this.resultsData?.updatedNomIds;
      if ( !updatedNomIds ) {
        return null;
      }

      return updatedNomIds.reduce((accNewsfeedItems, updatedNomId) => {
        const category = this.resultsData.categories.find(c => c.nomination_data.some(n => n.nom_id === updatedNomId));
        const nomination = category.nomination_data.find(n => n.nom_id === updatedNomId);
        const film = this.resultsData.films.find(f => f._id === nomination.film_id);

        // only post winning news on newsfeed
        if ( !nomination.won ) {
          return accNewsfeedItems;
        }

        let winText = `The winner of <i>${category.name}</i> is `;

        if ( Nomination.isActingCategory(category.name) ) {
          winText += `<b>${nomination.nominee}</b> in the film <b>${film.name}</b>`;

        } else if ( Nomination.isSongCategory(category.name) ) {
          winText += `<b>"${nomination.song_title}"</b> from the film <b>${film.name}</b>`;

        } else {
          winText += `<b>${film.name}</b>`;
        }

        // put first-choice winners first
        const contestantPointsText = this.resultsData.contestants.reduce((accPointMessages, curContestant) => {
          if ( curContestant.choices.includes(nomination.nom_id) ) {
            return [...accPointMessages, `+${category.points} points for ${curContestant.username}`];
          }
          return accPointMessages;
        }, []);

        // then add second-choice winners
        contestantPointsText.push( ...this.resultsData.contestants.reduce((accPointMessages, curContestant) => {
          if ( curContestant.second_choices.includes(nomination.nom_id) ) {
            return [...accPointMessages, `+${category.points_second_choice} points for ${curContestant.username}`];
          }
          return accPointMessages;
        }, []));

        if ( contestantPointsText.length === 0 ) {
          contestantPointsText.push(`no points awarded`);
        }

        return [...accNewsfeedItems, winText, ...contestantPointsText];

      }, []);

    },

    // connection states
    onConnectionOpen(/*event*/) {
      this.updateConnectionReadyState();
    },

    onConnectionClosedEvent(/*event*/) {
      this.eventSource.close();
      this.updateConnectionReadyState();
    },

    onConnectionError(/*event*/) {
      //console.log('connection error', event);
      this.updateConnectionReadyState();
    },
  }
}

</script>


<style scoped>
.results-container {
  .back-button {
    text-align: center;
    padding-bottom: 1.5em;

    a {
      color: var(--mol-color-gold-text);
      text-decoration: inherit;
    }
  }
}

.results-card {
  background-color: var(--bs-tertiary-bg);
  overflow: hidden;
  margin-bottom: 40px;
  padding: 3px 0 0 0;

  border: solid;
  border-width: 3px;
  border-color: var(--mol-color-gold);
  border-radius: 0.375rem;

  .card-header {
    background-color: inherit;
    text-align: center;
    width: 90%;
    font-size: smaller;
    margin: 1em auto 0 auto;
    padding: 1em 0 2em 0;
    border-style: none;

    .club-title {
      font-size: 1.1rem;
    }

    .ceremony-number-and-year {
      font-weight: bold;
      font-size: large;
    }
  }

  .card-body {
    padding-left: 1em;
    padding-right: 1em;
  }

  .card-footer {
    opacity: 50%;
    margin-top: 2em;
    padding-bottom: 2px;
    border-style: none;
    background-color: transparent;
    font-size: small;
    font-style: italic;
    color: var(--mol-color-gold-text);
    text-align: right;

  }
}

.news-feed {
  color: var(--mol-color-gold-text);
  font-size: small;
  margin-left: 25px;
}

.connection-indicator {
  position: absolute;
  top: 10px;
  left: 10px;

    position: absolute;

    display: inline-block;

    width: 10px;
    height: 10px;

    border-style: solid;
    border-radius: 50%;
    border-width: thin;
    border-color: var(--mol-color-gold);

    .connection-indicator-fill {
      background-color: white;
      height: 100%;
      width: 100%;
      border-radius: 50%;
    }

    &.open {
      border-color: limegreen;
      .connection-indicator-fill {
        background-color: limegreen;
        animation: pulseOpen 4s infinite;
      }
    }

    &.closed {
      border-color: lightgrey;
      .connection-indicator-fill {
        background-color: white;
      }
    }

    &.connecting {
      border-color: gold;
      .connection-indicator-fill {
        background-color: gold;
        animation: pulseConnecting 0.5s infinite;
      }
    }
  }



@keyframes pulseConnecting {
  0% {opacity: 100%;}
  50% {opacity: 0%;}
  100% {opacity: 100%;}
}

@keyframes pulseOpen {
  0% {opacity: 100%;}
  50% {opacity: 10%;}
  100% {opacity: 100%;}

}


tbody {
  tr {
    position: relative;

    border-width: thin;
    border-color: var(--mol-color-gold-text);
    border-style: solid none none none;

    &.no-top-border {
      border-top-style: none;
      border-color: var(--mol-color-gold-faded);
    }
    &.double-top-border {
      border-top-style: double;
      border-top-width: medium;
    }

    &:last-child {
      border-bottom-style: solid;
    }

    /*
    &:nth-child(even) {
      background-color: #fdf8ea;
    }
    */

    .image-table-data {
      width: 10px;
      opacity: 20%;
    }

    :deep(.rank-image) {
      display: inline;
      position: relative;
      z-index: 1;

      height: 40px;
      top: 2px;
      left: 2px;
      /*
      top: 3px;
      left: -25px;
      */
    }

    &.first-place {
      background-color: #F2F6FF;
      font-weight: 600;
    }

    &.second-place {
      background-color: #fdf0f2;
      font-weight: 600;
    }

    &.third-place {
      background-color: #fffff8;
      font-weight: 600;
    }
  }
}

.leaderboard-move,
.leaderboard-enter-active,
.leaderboard-leave-active {
  transition: all 0.5s ease;
}


html[data-bs-theme=dark] {
  .first-place {
    background-color: #001f56;
  }

  .second-place {
    background-color: #500008;
  }

  .third-place {
    background-color: #525200;
  }

  .image-table-data {
    opacity: 100%;
  }
}


</style>